/**
 * Simple Waveform Bar Component
 * Single bar for the historic waveform display
 */

interface WaveformBarProps {
  height: number; // 0-100 percentage
}

export function WaveformBar({ height }: WaveformBarProps) {
  return <div className="waveform-bar" style={{ height: `${height}%` }} />;
}
